<template>
  <div v-loading="loading">
    <div class="flex-between">
      <div class="title">学员详情</div>
      <el-button style="height: 100%" size="small" @click="goBack"
        >返回列表</el-button
      >
    </div>
    <el-card shadow="hover">
      <div slot="header">
        <span class="brand-color">学员档案</span>
      </div>
      <div class="flex">
        <div class="flex-item">
          <span class="flex-label">学员姓名：</span>
          <span>{{ studentInfo.realName }}</span>
        </div>
        <div class="flex-item">
          <span class="flex-label">用户名：</span>
          <span>{{ studentInfo.name }}</span>
        </div>
      </div>
      <div class="flex">
        <div class="flex-item">
          <span class="flex-label">导师：</span>
          <span>{{ studentInfo.mentorName }}</span>
        </div>
        <div class="flex-item">
          <span class="flex-label">导员：</span>
          <span>{{ studentInfo.guiderName }}</span>
        </div>
      </div>
      <div class="flex">
        <div class="flex-item">
          <span class="flex-label">路径名称：</span>
          <span>{{ studentInfo.pathName }}</span>
        </div>
        <div class="flex-item">
          <span class="flex-label">状态：</span>
          <span>{{ studentInfo.type }}</span>
        </div>
      </div>
    </el-card>

    <el-card shadow="hover">
      <div slot="header" class="flex-between">
        <span class="brand-color">任务列表</span>
        <zhu-button
          v-if="
            authPermissions.includes(
              'gongfu.api.fuwu_admin.study_paths.tasks.store'
            )
          "
          text="添加任务"
          :shadow="true"
          size="mini"
          type="primary"
          @click="addTask"
        >
        </zhu-button>
      </div>
      <el-alert title="可对任务进行拖拽排序哦～"></el-alert>
      <div class="task-title">
        <div class="task-title-container">
          <span class="task-name">任务名称</span>
          <span class="task-type">类型</span>
          <span class="task-start_time">开启时间</span>
          <span class="task-plan_time">计划结束时间</span>
          <span class="task-finish_time">完成时间</span>
          <span class="task-state">状态</span>
          <span
            v-if="
              authPermissions.includes(
                'gongfu.api.fuwu_admin.study_paths.tasks.show'
              ) ||
                authPermissions.includes(
                  'gongfu.api.fuwu_admin.study_paths.tasks.destroy'
                )
            "
            class="task-operation"
            >操作</span
          >
        </div>
      </div>
      <draggable
        class="task-content"
        ghost-class="ghost-class"
        dragClass="drag-class"
        v-model="taskList"
        :animation="150"
        :forceFallback="true"
        @update="sortTask"
        :disabled="
          !authPermissions.includes(
            'gongfu.api.fuwu_admin.study_paths.tasks.sort.update'
          )
        "
      >
        <transition-group>
          <div v-for="(item, index) in taskList" :key="item.id">
            <div class="task-content-item">
              <span class="task-name">{{ item.name }}</span>
              <span class="task-type">{{ item.component.source_type }}</span>
              <span class="task-start_time">
                <span v-if="item.start_at">{{ item.start_at }}</span>
                <span v-else>-</span>
              </span>
              <span class="task-plan_time">{{ item.plan_end_at }}</span>
              <span class="task-finish_time">
                <span v-if="item.finish_at">{{ item.finish_at }}</span>
                <span v-else>-</span>
              </span>
              <span class="task-state">
                <span v-if="item.finish_at">已完成</span>
                <span v-else>
                  <el-tooltip
                    :content="item.status ? '开启' : '关闭'"
                    placement="top"
                  >
                    <el-switch
                      v-model="item.status"
                      @change="changeTaskState(item.id, item.status)"
                      :disabled="
                        !authPermissions.includes(
                          'gongfu.api.fuwu_admin.study_paths.tasks.status.update'
                        )
                      "
                    ></el-switch>
                  </el-tooltip>
                </span>
              </span>
              <span class="task-operation">
                <el-link
                  v-if="
                    authPermissions.includes(
                      'gongfu.api.fuwu_admin.study_paths.tasks.show'
                    )
                  "
                  type="primary"
                  :underline="false"
                  @click="goTaskDetail(item.id)"
                  >详情</el-link
                >
                <el-divider
                  v-if="
                    authPermissions.includes(
                      'gongfu.api.fuwu_admin.study_paths.tasks.show'
                    ) &&
                      authPermissions.includes(
                        'gongfu.api.fuwu_admin.study_paths.tasks.destroy'
                      )
                  "
                  direction="vertical"
                ></el-divider>
                <el-link
                  v-if="
                    authPermissions.includes(
                      'gongfu.api.fuwu_admin.study_paths.tasks.destroy'
                    )
                  "
                  type="danger"
                  :underline="false"
                  @click="deleteTask(item.id, index)"
                  >删除</el-link
                >
              </span>
            </div>
          </div>
        </transition-group>
      </draggable>
    </el-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import draggable from "@/components/draggable";
import studentService from "@/global/service/student";

export default {
  components: {
    draggable
  },
  data() {
    return {
      loading: true,
      studentInfo: {
        name: "",
        realName: "",
        guiderName: "",
        mentorName: "",
        pathName: "",
        type: ""
      },
      taskList: []
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const id = this.$route.params.id;
      studentService
        .show(id)
        .then(res => {
          this.studentInfo.name = res.student.name;
          this.studentInfo.realName = res.student.realname
            ? res.student.realname
            : "-";
          this.studentInfo.guiderName = res.guider ? res.guider.realname : "-";
          this.studentInfo.mentorName = res.mentor ? res.mentor.realname : "-";
          this.studentInfo.pathName = res.name;
          this.studentInfo.type = res.status_label;
          this.taskList = res.tasks.map(data => {
            data.status = data.status === 1 ? false : true;
            return data;
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goBack() {
      this.$router.push({ name: "Student" });
    },
    addTask() {
      this.$router.push({ name: "StudentDetailTaskCreate" });
    },
    sortTask(evt) {
      const id = this.$route.params.id;
      const taskId = this.taskList[evt.newIndex].id;
      const sort =
        evt.newIndex > evt.oldIndex
          ? this.taskList[evt.newIndex - 1].sort
          : this.taskList[evt.newIndex + 1].sort;
      this.loading = true;
      studentService
        .taskSortEdit(id, taskId, { sort })
        .then(() => {
          this.getData();
          this.$message.success("排序成功");
        })
        .catch(() => {
          this.loading = false;
        });
    },
    changeTaskState(taskId, state) {
      const id = this.$route.params.id;
      const params = {
        status: state ? 2 : 1
      };
      this.loading = true;
      studentService.taskStateEdit(id, taskId, params).then(() => {
        if (state) {
          this.$message.success("开启成功");
        } else {
          this.$message.success("关闭成功");
        }
        this.getData();
      });
    },
    goTaskDetail(taskId) {
      this.$router.push({
        name: "StudentDetailTaskDetail",
        params: { taskId }
      });
    },
    deleteTask(taskId, index) {
      this.$confirm("此操作将永久删除该任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const id = this.$route.params.id;
          studentService.taskDel(id, taskId).then(() => {
            this.taskList.splice(index, 1);
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style lang="less" scoped>
.el-card {
  margin-bottom: 30px;
}
.flex {
  display: flex;
  margin-bottom: 12px;
  font-size: 14px;
  .flex-item {
    flex: 1;
  }
  .flex-label {
    display: inline-block;
    width: 70px;
    text-align: right;
  }
}
.task-title,
.task-content {
  margin: 0 auto;
  width: 898px;
  font-size: 12px;
  .task-title-container {
    display: flex;
    margin: 24px 0 12px;
    font-weight: 700;
    color: #909399;
  }
  .task-content-item {
    display: flex;
    margin-bottom: 8px;
    height: 40px;
    line-height: 40px;
    color: #606266;
    border: 1px solid #ebeef5;
    cursor: grab;
  }
  .task-name,
  .task-type,
  .task-start_time,
  .task-plan_time,
  .task-finish_time,
  .task-state,
  .task-operation {
    flex: 1;
    padding: 0 12px;
    text-align: center;
    overflow: hidden;
  }
  .task-type,
  .task-state,
  .task-operation {
    flex: none;
    width: 100px;
  }
}
.ghost-class {
  background: #e7f9e6;
}
.drag-class {
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
